module.exports = __webpack_public_path__ + "gary-reynolds.jpg";